import queryString from 'query-string';
import { BASE_URL } from '../configs/config';
import { useSystemContext } from '../context/SystemContext/SystemContext';

const usePaymentMethod = () => {
  const { seatInfo, stadiumInfo } = useSystemContext();

  const payment = async (amount: number, orderNo: string, location_id: string, merchant_id: string) => {
    try {
      if (!stadiumInfo?.id || !seatInfo?.id) {
        return;
      }

      const hostPath = window.location.origin;
      const orderDetailLink = queryString.stringifyUrl({
        url: `/orderdetail/${orderNo}`,
        query: {
          seatID: seatInfo?.id,
          stadiumID: stadiumInfo?.id,
        },
      });

      const response = await fetch(`${BASE_URL}createPaymentCode`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          amount,
          orderId: orderNo,
          locationId: location_id,
          merchantId: merchant_id,
          frontUrl: `${hostPath}${orderDetailLink}`,
          stadiumID: stadiumInfo.id,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('Error creating payment code', errorData);
        return;
      }

      return await response.json();
    } catch (error) {
      console.error('Error ', error);
    }
  };

  return {
    payment,
  };
};

export default usePaymentMethod;
